import React from 'react';
import { DatePicker } from 'antd';
import { RangePickerProps } from 'antd/lib/date-picker';

const { RangePicker } = DatePicker;

const DEFAULT_FORMAT = 'YYYY-MM-DD';

type Props = RangePickerProps & {
	status?: '' | 'warning' | 'error';
	dropdownClassName?: string;
	popupClassName?: string;
};

const RangeCalendar: React.FunctionComponent<Props> = (props: Props) => {
	return (
		<RangePicker
			allowClear={false}
			format={DEFAULT_FORMAT}
			{...props}
			className={`bringg-picker ${props.className || ''}`}
			popupClassName={`bringg-picker-dropdown ${props.popupClassName || ''}`}
		/>
	);
};

export default RangeCalendar;
